<template>
  <div class="card">
    <div class="p-6">
      <div class="flex items-center justify-between mb-6">
        <div>
          <div class="font-semibold text-lg">{{ dimension.name }}</div>
          <p class="text-sm text-gray-600 mt-1">{{ dimension.description }}</p>
        </div>
        <div class="text-right">
          <span class="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold bg-gray-100 text-gray-700 border-gray-200">
            {{ answeredInDimension }} / {{ dimension.questions.length }}
          </span>
          <div class="relative overflow-hidden rounded-full bg-gray-200 h-1 w-20 mt-2">
            <div 
              class="h-full bg-psychology-primary transition-all duration-300"
              :style="{ width: dimensionProgress + '%' }"
            ></div>
          </div>
        </div>
      </div>

      <!-- 题目列表 -->
      <div class="space-y-6">
        <QuestionCard
          v-for="(question, index) in dimension.questions"
          :key="question.id"
          :question="question"
          :question-number="dimensionIndex * 10 + index + 1"
          :answer="answers[question.id]"
          @answer="handleAnswer"
        />
      </div>
    </div>
  </div>
</template>

<script>
import QuestionCard from './QuestionCard.vue'

export default {
  name: 'DimensionQuestions',
  components: {
    QuestionCard
  },
  props: {
    dimension: {
      type: Object,
      required: true
    },
    dimensionIndex: {
      type: Number,
      required: true
    },
    answers: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    answeredInDimension() {
      return this.dimension.questions.filter(q => this.answers[q.id] !== undefined).length
    },
    dimensionProgress() {
      return Math.round((this.answeredInDimension / this.dimension.questions.length) * 100)
    }
  },
  methods: {
    handleAnswer(data) {
      this.$emit('answer', data)
    }
  }
}
</script>

